export interface AdmpNewsSearchData {
  status: boolean | undefined | null; // true(read)/false(unread)/ALL(undefined)
  favorite: boolean | undefined | null; // true/false/ALL(undefined)
  datum: any; // date
}

function defaultData(): AdmpNewsSearchData {
  return {
    status: undefined,
    favorite: undefined,
    datum: undefined,
  };
}

export default {
  defaultData,
};
